import React from 'react';
import type { Theme } from 'baseui';
import { useStyletron } from 'baseui';
import { Tag } from 'baseui/tag';
import { KEYFRAME_STEPPER_ADJUST_LABEL, KEYFRAME_STEPPER_MAX_VISIBLE_CHIPS } from './constants';
type PropsT = {
  chips: number[];
  maxVisible?: number;
};
const getTagOverrides = (theme: Theme) => ({
  Root: {
    style: {
      margin: 0,
      fontSize: theme.typography.LabelXSmall.fontSize
    }
  },
  Text: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      fontSize: $theme.typography.LabelXSmall.fontSize
    })
  }
});

/**
 * Presentational keyframe chips for the enhanced tracking modal:
 * "Adjust the bounding box in the key frames" + the first `maxVisible` keyframe
 * frames as tags, followed by "+N more" when there are additional keyframes.
 */
export const KeyframeStepperDisplay = ({
  chips,
  maxVisible = KEYFRAME_STEPPER_MAX_VISIBLE_CHIPS
}: PropsT) => {
  const [css, theme] = useStyletron();
  if (chips.length === 0) {
    return null;
  }
  const visibleChips = chips.slice(0, maxVisible);
  const remainingCount = chips.length - visibleChips.length;
  return <>
      <div className={css({
      fontSize: theme.typography.LabelSmall.fontSize,
      color: theme.colors.contentSecondary,
      padding: theme.sizing.scale0
    })}>
        {KEYFRAME_STEPPER_ADJUST_LABEL}
      </div>
      <div className={css({
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      padding: theme.sizing.scale100,
      gap: theme.sizing.scale200
    })}>
        {visibleChips.map(frame =>
      // Frames are 0-indexed internally; display 1-indexed to match Existing Sequences.
      <Tag key={frame} closeable={false} kind="accent" overrides={getTagOverrides(theme)}>
            {frame + 1}
          </Tag>)}
        {remainingCount > 0 && <span className={css({
        fontSize: theme.typography.LabelXSmall.fontSize,
        color: theme.colors.contentTertiary
      })}>
            +{remainingCount} more
          </span>}
      </div>
    </>;
};